import timerMixin from './timer';

export default {
  mixins: [timerMixin],
  computed: {
    currentStatusStartTime() {
      return this.$store.state.callTimeAndAlert.currentStatusStartTime;
    },
    maxCallTimeHuman() {
      return this.$store.state.callTimeAndAlert.callAlertConfig.humanMaxDuration;
    },
    textAlertHuman() {
      return this.$store.state.callTimeAndAlert.callAlertConfig.textOnAlert || 'Tiempo máximo de llamada excedido...';
    },
    warningStart() {
      return this.maxCallTimeHuman - this.$store.state.callTimeAndAlert.callAlertConfig.timeShowAlertFromMax;
    },
    warningTime() {
      if (this.seconds < this.warningStart) {
        return '00 s';
      }
      const timeLeft = this.maxCallTimeHuman - this.seconds;
      if (timeLeft <= 60) {
        return `${String(timeLeft).padStart(2, '0')} s`;
      }
      return this.convertSecondsInTimeWithFormat(timeLeft);
    },
    callInProgress() {
      return this.$store.state.callTimeAndAlert.isOnManualCall || this.$store.state.dialer.callCenterStatus === 3 || this.$store.state.dialerV2.status === 3;
    },
    currentTimeStep() {
      if (!this.callInProgress || !this.maxCallTimeHuman || !this.currentStatusStartTime || (this.seconds < this.warningStart)) {
        return 'None';
      }
      if (this.seconds >= this.maxCallTimeHuman) {
        return 'Exceeds';
      }
      return 'Warning';
    },
    showWarningTime() {
      return this.currentTimeStep === 'Warning';
    },
    showAlertTime() {
      return this.currentTimeStep === 'Exceeds';
    },
    soundIsRunning() {
      return this.$store.state.callTimeAndAlert.sound != null;
    },
  },
  methods: {
    initSound() {
      const ruteMP3 = require('@/assets/sound/call_alert.mp3');
      return this.$store.dispatch('callTimeAndAlert/initSound', { soundURL: ruteMP3, callId: this.currentCallId });
    },
    endSound() {
      return this.$store.dispatch('callTimeAndAlert/endSound');
    },
  },
  watch: {
    showAlertTime(newVal, oldVal) {
      if (!oldVal && newVal) {
        this.initSound();
      }
    },
  },
  beforeDestroy() {
    this.endSound();
  },
};



// WEBPACK FOOTER //
// ./src/mixins/callTimeAndAlert.js